export function loadAnimalCategories() {
    (function($) {
        function caricaCategorie(pagina = 1) {
            $.ajax({
                url: ajax_object.ajax_url, // URL AJAX di WordPress
                type: 'post',
                data: {
                    action: 'get_animals_categories_ajax',
                    paged: pagina
                },
                beforeSend: function() {
                    $('#categorie-container').html('<p>Caricamento...</p>');
                },
                success: function(response) {
                    $('#categorie-container').html(response);
                },
                error: function(error) {
                    console.log('Errore AJAX:', error);
                }
            });
        }

        // Carica la prima pagina all'avvio
        caricaCategorie();

        // Gestisce la navigazione AJAX
        $(document).on('click', '.prev-page, .next-page', function() {
            var pagina = $(this).data('page');
            caricaCategorie(pagina);
        });

    })(jQuery);
}
